export enum GelatoSubscriptionModalType {
  GENERAL = 'general',
  GELATO_PLUS = 'gelato-plus',
  GELATO_GOLD = 'gelato-gold',
}
